var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1923 6H6.80765C5.12027 6 4.27658 6 3.63268 6.32971C3.07242 6.61659 2.61659 7.07242 2.32971 7.63268C2 8.27658 2 9.12027 2 10.8077C2 11.2366 2 11.4511 2.07336 11.6319C2.13743 11.7898 2.24079 11.9288 2.37363 12.0355C2.52574 12.1577 2.73118 12.2194 3.14206 12.3426L8.5 13.95V15.1627C8.5 15.9283 8.95939 16.6341 9.68682 16.9296L10.2469 17.1572C11.3719 17.6143 12.6281 17.6143 13.7531 17.1572L14.3132 16.9296C15.0406 16.6341 15.5 15.9283 15.5 15.1627V13.95L20.8579 12.3426C21.2688 12.2194 21.4743 12.1577 21.6264 12.0355C21.7592 11.9288 21.8626 11.7898 21.9266 11.6319C22 11.4511 22 11.2366 22 10.8077C22 9.12027 22 8.27658 21.6703 7.63268C21.3834 7.07242 20.9276 6.61659 20.3673 6.32971C19.7234 6 18.8797 6 17.1923 6ZM13.6 13H10.4C10.1791 13 10 13.1819 10 13.4063V15.1627C10 15.3288 10.0996 15.4782 10.2514 15.54L10.8116 15.7675C11.5745 16.0775 12.4255 16.0775 13.1885 15.7675L13.7486 15.54C13.9004 15.4782 14 15.3288 14 15.1627V13.4063C14 13.1819 13.8209 13 13.6 13Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.9579 12.3126C20.9469 12.3159 20.9356 12.3193 20.9242 12.3227L15.5 13.9501V15.1627C15.5 15.9283 15.0406 16.6341 14.3132 16.9296L13.7531 17.1572C12.6281 17.6143 11.3719 17.6143 10.2469 17.1572L9.68682 16.9296C8.95939 16.6341 8.5 15.9283 8.5 15.1627V13.9501L3 12.2999C3.0009 15.9752 3.03489 19.6879 4.318 20.8285C5.63601 22.0001 7.75733 22.0001 12 22.0001C16.2426 22.0001 18.3639 22.0001 19.682 20.8285C20.9651 19.6879 20.9991 15.9752 21 12.2999L20.9579 12.3126Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.1709 4C9.58273 2.83481 10.694 2 12.0002 2C13.3064 2 14.4177 2.83481 14.8295 4",
    stroke: "#454545",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.4c8cea24f609437f56255ed4a830d105.svg";
export { ForwardRef as ReactComponent };